import { useState, useCallback } from 'react';
import { isMobile } from 'react-device-detect';

export const useMainPageUI = () => {
  // Initialize tab value from URL like the original code
  const getInitialTabValue = () => {
    try {
      const urlParts = window.location.href.split("/");
      const tabValue = Number(urlParts[urlParts.length - 2]); // Second to last part should be tab value
      return isNaN(tabValue) ? 0 : tabValue;
    } catch {
      return 0;
    }
  };

  // Panel and layout state (used for desktop layout)
  const [sizes, setSizes] = useState(isMobile ? ['100%', 'auto'] : ['30%', 'auto']);
  const [rightPanelTabValue, setRightPanelTabValue] = useState(getInitialTabValue);
  
  // Accordion state
  const [pinnedAccordionExpanded, setPinnedAccordionExpanded] = useState(true);
  const [regularAccordionExpanded, setRegularAccordionExpanded] = useState(true);

  // Panel size management (used for desktop layout)
  const updatePanelSizes = useCallback((newSizes) => {
    setSizes(Array.isArray(newSizes) ? newSizes : [newSizes, 'auto']);
  }, []);

  // Tab management
  const handleTabChange = useCallback((newValue) => {
    setRightPanelTabValue(newValue);
  }, []);

  // Accordion handlers
  const handlePinnedAccordionChange = useCallback((event, isExpanded) => {
    setPinnedAccordionExpanded(isExpanded);
  }, []);

  const handleRegularAccordionChange = useCallback((event, isExpanded) => {
    setRegularAccordionExpanded(isExpanded);
  }, []);

  return {
    // State
    sizes,
    rightPanelTabValue,
    pinnedAccordionExpanded,
    regularAccordionExpanded,
    
    // Actions
    updatePanelSizes,
    handleTabChange,
    handlePinnedAccordionChange,
    handleRegularAccordionChange
  };
}; 